module.exports = __webpack_public_path__ + "static/media/tanker_road.c39c21d2.png";